<!--
 * @Project:
 * @Remark:
 * @Author: YJKJ
 * @Date: 2021-03-03 16:09:08
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-12 17:18:29
-->
<template>
  <div id="app">
    <div class="nav-bar-p" v-if="!$route.meta.noNavBar">
      <van-nav-bar
        :key="$route.fullPath"
        :title="$route.meta.title"
        left-text="返回"
        right-text="首页"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"/>
    </div>

    <keep-alive :include="include">
      <router-view />
    </keep-alive>
    <article class="load-wrapper" v-if="load.show">
      <img :src="`../../../static/image/icon/loading.gif`" />
    </article>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { NavBar } from 'vant';

import { openDebugger } from '@/utils';

const isLocalOrProd = location.host.indexOf('localhost') >= 0 || location.host.indexOf('aiybzn.com') >= 0;
if (!isLocalOrProd || location.href.split('?').indexOf('debug=1') > -1) {
  openDebugger({
    open: true,
  });
}

export default {
  name: 'App',
  components: {
    vanNavBar: NavBar,
  },
  data() {
    return {
      include: ['walletIncomeTotal'], // 'machineDetails', 'aisleDetails',
    };
  },
  computed: {
    ...mapState(['load']),
  },
  created() {
    this.syncOverlayOffset(this.$route);
  },
  watch: {
    $route(to) {
      this.syncOverlayOffset(to);
      if (to.path == '/addVendingEasily' && this.include.indexOf('addVendingEasily') == -1) {
        this.include.push('addVendingEasily');
      } else if (to.path != '/addVendingEasily' && to.path != '/vendingEasilyGoods') {
        const index = this.include.indexOf('addVendingEasily');
        if (index != -1) {
          this.include.splice(index, 1);
        }
      }
      if (to.path == '/vendingEasilyDetail' && this.include.indexOf('vendingEasilyDetail') == -1) {
        this.include.push('vendingEasilyDetail');
      } else if (to.path != '/vendingEasilyDetail' && to.path != '/vendingEasilyGoods') {
        const index = this.include.indexOf('vendingEasilyDetail');
        if (index != -1) {
          this.include.splice(index, 1);
        }
      }

      if (to.path != '/vendingEasilyDetail' && to.path != '/vendingEasilyGoods' && to.path != '/addVendingEasily') {
        sessionStorage.removeItem('vendingEasilyMachineList');
      }
    },
  },
  methods: {
    syncOverlayOffset(route) {
      const offset = route && route.meta && route.meta.noNavBar ? '0px' : 'var(--h5-nav-height)';
      document.documentElement.style.setProperty('--h5-page-offset', offset);
      document.documentElement.style.setProperty('--h5-notify-offset', offset);
    },
    onClickLeft() {
      this.$router.back();
    },
    onClickRight() {
      this.$router.push({ name: 'home' });
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.nav-bar-p {
  height var(--h5-nav-height)
}
.van-nav-bar {
  background: var(--h5-surface);
  color: var(--h5-text);
  position: fixed;
  width: 100vw;
  top: 0;
  left: 0;
  z-index 20
  border-bottom: 1px solid var(--h5-border)
  box-shadow: 0 2px 10px rgba(30, 52, 90, .06)

  /deep/ .van-nav-bar__text, /deep/ .van-icon {
    color var(--h5-primary)
  }
  /deep/ .van-nav-bar__title {
    color var(--h5-text)
    font-size 16px
    font-weight 600
  }
}
.load-wrapper {
  width: 100vw;
  height: 100vh;
  line-height: 100vh;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  background: #fff;
  text-align: center;
  font-size: 1.5rem;
  color: #464646;

  img {
    width: 30rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue